<template>
  <transition name="modal">
    <div class="modal">
      <div class="mask">
        <div
          @click="$emit('close')"
          class="overlay">
        </div>

        <div class="wrapper">
          <div class="panel">
            <svg
              class="close"
              :class="{
                'video-close': video
              }"
              @click="$emit('close')"
              viewBox="0 0 35.33 35.33"
              width="23.70"
              height="23.70"
            >
              <path
                fill="none"
                stroke="#000"
                stroke-miterlimit="10"
                stroke-width="4"
                d="M1.41 1.41l32.5 32.5M33.91 1.41l-32.5 32.5"
              />
            </svg>

            <div class="container">

              <main class="body">
                <div
                  v-if="this.$slots['video']"
                  class="video"
                >
                  <slot name="video"></slot>
                </div>
                <div
                  v-if="this.$slots['image'] || this.$slots['title'] || this.$slots['body'] || this.$slots['buttons']"
                  class="row"
                >
                  <figure
                    v-if="this.$slots['image']"
                    class="figure"
                  >
                    <slot name="image"></slot>
                  </figure>

                  <div class="entry">
                    <header
                      v-if="this.$slots['title']"
                      class="header"
                    >
                      <slot name="title"></slot>
                    </header>

                    <div class="content">
                      <slot name="body"></slot>
                    </div>

                    <div
                      v-if="this.$slots['buttons']"
                      class="buttons"
                    >
                      <slot name="buttons"></slot>
                    </div>
                  </div>
                </div>
              </main>

              <footer
                v-if="this.$slots['footer']"
                class="footer"
              >
                <slot name="footer">
                  <Button theme="yellow">
                    <span @click="$emit('close')">
                      OK
                    </span>
                  </Button>
                </slot>
              </footer>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Button from '@/components/Button'

export default {
  name: 'Modal',
  props: {
    video: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Button
  }
}
</script>

<style lang="scss" scoped>
  .modal {
    transition: all .3s ease;
    position: relative;
    z-index: 100;
  }
  .mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: all .3s ease;
  }
  .overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .wrapper {
    display: table-cell;
    vertical-align: middle;
  }
  .panel {
    max-width: 960px;
    background-color: white;
    margin: 0 auto;
    position: relative;


    @media (max-width: 767px) {
      padding: 30px 24px;
    }
  }
  .close {
    cursor: pointer;
    position: absolute;
    top: 17px;
    right: 17px;
    z-index: 1;
  }
  .video-close {
    top: -40px;
    right: 0;

    path {
      stroke: white;
    }
  }
  .container {
    @extend %container;
    padding-left: 0;
    padding-right: 0;
  }
  .row {
    @extend %row;

    display: flex;
  }
  .figure {
    @extend %col-sm-6;
  }
  .entry {
    @extend %col-sm-6;

    padding: 60px 54px;
    min-height: 100%;
  }

  .header {
  }
  .title {
    margin-top: 0;
  }
  .body {
  }
  .video {
    width: 100%;
    font-size: 0;
  }
  .content {
    font-size: 16px;
  }
  .modal-enter {
    opacity: 0;
  }
  .modal-leave-active {
    opacity: 0;
  }
  .modal-enter .mask,
  .modal-leave-active .mask {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue